import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledComparisonFeatureComponent } from "./comparison-feature-component.scss";
import VIcon from "/static/svg/competitors-template/v.svg";
import XIcon from "/static/svg/competitors-template/x.svg";
class ComparisonFeatureComponent extends PureComponent {
    renderFeatureValueContnet(value) {
        if (value === "true") return /*#__PURE__*/ _jsx(VIcon, {
            fill: "#00D647"
        });
        if (value === "false") return /*#__PURE__*/ _jsx(XIcon, {});
        return value;
    }
    renderFeatureValue(value) {
        return /*#__PURE__*/ _jsx("div", {
            className: "feature-value",
            children: this.renderFeatureValueContnet(value)
        });
    }
    render() {
        const { title, monday, competitor, index, bigTexts } = this.props;
        return /*#__PURE__*/ _jsxs(StyledComparisonFeatureComponent, {
            className: "table-row-wrapper",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `table-row table-feature ${index % 2 == 0 ? "even" : "odd"} ${bigTexts ? "big-texts" : ""}`,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "table-cell first-cell",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "table-cell",
                            children: this.renderFeatureValue(monday)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "table-cell"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "table-cell",
                            children: this.renderFeatureValue(competitor)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "table-cell"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `mobile-table-row ${bigTexts ? "big-texts" : ""}`,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "feature-title",
                            children: title
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "feature-cells",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(monday)
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(competitor)
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
export { ComparisonFeatureComponent as default };
ComparisonFeatureComponent.defaultProps = {
    title: null,
    monday: null,
    competitor: null
};
